import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "home-outline",
  "use": "home-outline-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"home-outline\"><path d=\"M10.5,15.5 L10.5,12.411 L10.469,12.327 C10.402,12.146 10.242,11.782 9.915,11.37 C9.383,10.701 8.739,10.362 8,10.362 C7.261,10.362 6.617,10.701 6.085,11.37 C5.758,11.782 5.598,12.146 5.531,12.326 L5.5,12.411 L5.5,15.5 L0.5,15.5 L0.5,6.25 L8,0.625 L15.5,6.25 L15.5,15.5 L10.5,15.5 Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/home-outline.svg
// module id = 728
// module chunks = 0